module.exports = __webpack_public_path__ + "assets/img/img_2_9_3.6a050184.png";